import _ from 'lodash';
import dayjs from 'dayjs';
import { flattenDeep } from 'lodash';
import { connect } from 'react-redux';
import { StyledBox, StyledBoxHeader } from '../../../CSS/style';
import { DownOutlined } from '@ant-design/icons';
import { decode as base64_decode } from 'base-64';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';
import StyledTable from '../../../../../commons/styles/table';

import { API_INSPECTIONCONFIG } from '../../../../../commons/api';
import TextAreaComponent from '../../../Widgets/TextAreaComponent';
import { message, Tree, Space, Form, DatePicker, Select, Checkbox, Button } from 'antd';
import {
  getQuestionDeviceList,
  getInspectionQuestions,
  getServiceReqId,
  submitInspection,
  getAreasList,
  getUsersList,
  getDataSourceOfInspectionById,
  submitMaster,
  getEquipmentHierarchyForInspection,
  getStatusListInspection
} from '../../../Utils/FormCalls';
import { StyledHomepageSides } from '../../../../../commons/styles/layout';

const { Option } = Select;
const type = 'Item';
const urlList = {
  insert: API_INSPECTIONCONFIG.UpdateInsStatus
};

const InspectionForm = (props) => {
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [datasource, setDatasource] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [fileUploadList, setFileUploadList] = useState([]);
  const [dataRef, setDataRef] = useState({});
  const [usersList, setUsersList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [InspectionId, setInspectionId] = useState('');
  const formHeader = useRef();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  console.log(windowHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (windowWidth < 768) {
    containerStyle.flexDirection = 'column';
  }
  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      await getQuestionDeviceList();
      await getAreasList();
      const usersList = await getUsersList();
      const statusList = await getStatusListInspection();
      setUsersList(usersList);
      setStatusList(statusList);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props.translationCache, props.formObject]);

  const _getDataById = async () => {
    const path = props.location.pathname.split('/rubus/AMM/InspectionDetails/');
    const formId = base64_decode(path[1]);
    if (formId !== 'new') {
      const formObject = await getDataSourceOfInspectionById(formId);
      _.cloneDeepWith(formObject, (value) => {
        return value && value !== undefined && value !== null
          ? {
            ...(value['InspectionCreationTime']
              ? (value['InspectionCreationTime'] = dayjs
                .utc(value.InspectionCreationTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['ActualEndDate']
              ? (value['ActualEndDate'] = dayjs.utc(value.ActualEndDate, 'YYYY-MM-DD HH:mm:ss'))
              : null)
          }
          : _.noop();
      });
      await getEquipmentHierarchy(formId);
      setFormObject(formObject);
      if (formHeader.current) {
        formHeader.current.setFieldsValue(formObject);
      }
    }
  };

  const getEquipmentHierarchy = async (InspectionId) => {
    const treeData = await getEquipmentHierarchyForInspection(InspectionId);
    if (treeData) {
      expandAll(treeData);
    }
    setTreeData(treeData);
    setInspectionId(InspectionId);
  };

  const onFormsubmit = async (rowIndex) => {
    const siteId = localStorage.get('currentSite');
    let payload = {};
    if (
      datasource &&
      datasource[rowIndex] &&
      datasource[rowIndex].payload &&
      datasource[rowIndex].payload.Option
    ) {
      const selectedOption = datasource[rowIndex].payload.Option;
      const Answers = datasource[rowIndex].Answers;

      const AnswerObject =
        Answers && Array.isArray(Answers) && Answers.filter((e) => e.Option === selectedOption);
      if (
        AnswerObject &&
        AnswerObject[0] &&
        AnswerObject[0].Actions &&
        Array.isArray(AnswerObject[0].Actions) &&
        AnswerObject[0].Actions[0]
      ) {
        if (
          AnswerObject[0].Actions[0] === 'ServiceRequest' &&
          datasource[rowIndex].Remarks &&
          datasource[rowIndex].Remarks.length > 0
        ) {
          if (datasource && datasource[rowIndex] && datasource[rowIndex].Answer) {
            const AnswersList = datasource[rowIndex].Answers || [];
            const selected = AnswersList.filter(
              (answersObject) => answersObject.Option === datasource[rowIndex].Answer
            );
            if (
              selected &&
              selected[0] &&
              selected[0].Actions &&
              Array.isArray(selected[0].Actions) &&
              selected[0].Actions[0] &&
              selected[0].Actions[0] === 'ServiceRequest'
            ) {
              const gerSeviceReqId = await getServiceReqId();
              datasource[rowIndex].ServiceReq = datasource[rowIndex].Answer;
              payload = {
                SiteId: siteId,
                SRId: gerSeviceReqId.SR
              };
            }
          }
          const fileList = fileUploadList && fileUploadList[rowIndex] ? fileUploadList[rowIndex] : [];

          const object = {
            Ciq_InspectionId: datasource[rowIndex].Id,
            Remarks: datasource[rowIndex].Remarks,
            Answer: datasource[rowIndex].Answer,
            ServiceReq: { ...payload },
            Attachments: datasource[rowIndex].Attachments
          };
          const InspectionResponse = await submitInspection(object, fileList, 'InspectionQuestion');
          if (InspectionResponse && InspectionResponse.message) {
            message.success(InspectionResponse.message);
            const questionPayload = {
              DeviceAlias: dataRef && dataRef['DeviceAlias'] ? dataRef['DeviceAlias'] : '',
              AreaId: dataRef && dataRef['ParentId'] ? dataRef['ParentId'] : '',
              ItemId: dataRef && dataRef['Code'] ? dataRef['Code'] : '',
              currentDate: dayjs().utc().format('YYYY-MM-DD'),
              Id: InspectionId ? InspectionId : ''
            };
            const newDatasource = await getInspectionQuestions(questionPayload, 'Questions');
            setDatasource(newDatasource);
            setFileUploadList({ ...fileUploadList, [rowIndex]: [] });
          } else if (InspectionResponse && InspectionResponse.Error) {
            message.error(InspectionResponse.Error);
          }
        } else {
          message.warning('Please enter remarks before submitting');
        }
      } else {
        const fileList = fileUploadList && fileUploadList[rowIndex] ? fileUploadList[rowIndex] : [];

        const object = {
          Ciq_InspectionId: datasource[rowIndex].Id,
          Remarks: datasource[rowIndex].Remarks,
          Answer: datasource[rowIndex].Answer,
          ServiceReq: { ...payload },
          Attachments: datasource[rowIndex].Attachments
        };
        const InspectionResponse = await submitInspection(object, fileList, 'InspectionQuestion');
        if (InspectionResponse && InspectionResponse.message) {
          message.success(InspectionResponse.message);
          const questionPayload = {
            DeviceAlias: dataRef && dataRef['DeviceAlias'] ? dataRef['DeviceAlias'] : '',
            AreaId: dataRef && dataRef['ParentId'] ? dataRef['ParentId'] : '',
            ItemId: dataRef && dataRef['Code'] ? dataRef['Code'] : '',
            currentDate: dayjs().utc().format('YYYY-MM-DD'),
            Id: InspectionId ? InspectionId : ''
          };
          const newDatasource = await getInspectionQuestions(questionPayload, 'Questions');
          setDatasource(newDatasource);
          setFileUploadList({ ...fileUploadList, [rowIndex]: [] });
        } else if (InspectionResponse && InspectionResponse.Error) {
          message.error(InspectionResponse.Error);
        }
      }
    } else {
      message.error('Please select Answer');
    }
  };

  const fileupload = async (values, key, fileDataObject, rowIndex) => {
    let newDatasource = [...datasource];
    if (newDatasource[rowIndex][key]) {
      newDatasource[rowIndex][key].push(...values);
    } else {
      newDatasource[rowIndex][key] = values;
    }
    newDatasource[rowIndex][key] =
      newDatasource[rowIndex][key] &&
      newDatasource[rowIndex][key].reduce((acc, current) => {
        const x = acc.find((item) => item.Name === current.Name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    newDatasource[rowIndex] = {
      ...newDatasource[rowIndex],
      [key]: newDatasource[rowIndex][key],
      fileDataObject
    };

    const newFileUploadList = {
      ...fileUploadList,
      [rowIndex]: [
        ...(fileUploadList && fileUploadList[rowIndex] ? fileUploadList[rowIndex] : []),
        fileDataObject
      ]
    };

    setDatasource(newDatasource);
    setFileUploadList(newFileUploadList);
  };

  const onCheckboxChange = (Answer, rowIndex, Option) => {
    const newDatasource = [...datasource];
    newDatasource[rowIndex] = {
      ...newDatasource[rowIndex],
      Answer: Answer.target.checked === true ? Option : null,
      payload: {
        ...newDatasource[rowIndex].payload,
        QuestionId: newDatasource[rowIndex].Id,
        Answer: Answer.target.checked,
        Option
      }
    };
    setDatasource(newDatasource);
  };

  const translation = (keyword) => {
    return props.translationCache && props.translationCache[keyword] ? props.translationCache[keyword] : keyword;
  };

  const setRemarks = (Remarks, rowIndex) => {
    const newDatasource = [...datasource];
    newDatasource[rowIndex] = {
      ...newDatasource[rowIndex],
      Remarks,
      payload: {
        ...newDatasource[rowIndex].payload,
        Remarks
      }
    };
    setDatasource(newDatasource);
  };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <Tree.TreeNode
              title={
                item && !item.ParentId
                  ? `${translation(item.DisplayCode)}(${translation(item.Name)})`
                  : translation(item.Name)
              }
              key={item.key}
              dataRef={item}
            >

              {renderTreeNodes(item.children, item)}
            </Tree.TreeNode>
          );
        }
        return (
          <Tree.TreeNode
            key={item.key}
            title={<div style={{ color: 'white' }}>{translation(item.Name)}</div>}
            dataRef={item}
          />
        );
      })
    );
  };

  const onSelect = async (selectedKeys, info) => {
    const status =
      info &&
      info['selectedNodes'] &&
      info['selectedNodes'][0] &&
      info['selectedNodes'][0]['dataRef'] &&
      info['selectedNodes'][0]['dataRef']['Type'] &&
      info['selectedNodes'][0]['dataRef']['Type'] === 'Items';
    if (status) {
      const dataRef =
        info &&
          info['selectedNodes'] &&
          info['selectedNodes'][0] &&
          info['selectedNodes'][0]['dataRef']
          ? info['selectedNodes'][0]['dataRef']
          : {};

      const questionPayload = {
        DeviceAlias: dataRef && dataRef['DeviceAlias'] ? dataRef['DeviceAlias'] : '',
        AreaId: dataRef && dataRef['ParentId'] ? dataRef['ParentId'] : '',
        ItemId: dataRef && dataRef['Code'] ? dataRef['Code'] : '',
        currentDate: dayjs().utc().format('YYYY-MM-DD'),
        Id: InspectionId ? InspectionId : ''
      };
      const newDatasource = await getInspectionQuestions(questionPayload, 'Questions');
      setDatasource(newDatasource);
      setDataRef(dataRef);
    } else if (status === false) {
      message.error('Please Select Item');
    }
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const expandAll = async (treeData) => {
    const expandedKeys = await getAllKeys(treeData);
    setExpandedKeys(expandedKeys);
  };

  const getAllKeys = (data) => {
    const nestedKeys = data.map((node) => {
      let childKeys = [];
      if (node.children) {
        childKeys = getAllKeys(node.children);
      }
      return [childKeys, node.key];
    });
    return flattenDeep(nestedKeys);
  };

  const handleChange = async (value, key) => {
    let formObject = formHeader && formHeader.current && formHeader.current.getFieldsValue();

    formObject = {
      ...formObject,
      [key]: value
    };

    formHeader && formHeader.current && formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onFormsubmit1 = async (values) => {
    const siteId = localStorage.get('currentSite');
    const userId =
      props.userProfile && props.userProfile.user && props.userProfile.user.Id
        ? props.userProfile.user.Id
        : '';
    const payload = {
      ...formObject,
      ...values,
      ...(InspectionId ? { Id: InspectionId } : ''),
      ...(formObject && formObject.Id ? { UpdatedBy: userId } : {}),
      Ciq_InspectionId: values.Id,
      SiteId: siteId
    };
    const statusResponse = await submitMaster(urlList.insert, payload, null, type);
    if (statusResponse) {
      message.success(statusResponse.message);
    }
  };

  const columns = [
    {
      title: translation('Question'),
      dataIndex: 'Question',
      key: 'Question'
    },
    {
      title: translation('Options'),
      dataIndex: 'Answer',
      key: 'Answer',
      render: (_, data, rowIndex) => (
        <Space>
          {data &&
            data.Answers.map((item) => {
              return (
                <>
                  <Checkbox
                    className="check"
                    key={item.Option}
                    value={datasource[rowIndex].Answer}
                    disabled={
                      data.InspectionLogBook && data.InspectionLogBook.length !== 0 ? true : false
                    }
                    checked={
                      data.InspectionLogBook &&
                        data.InspectionLogBook[0] &&
                        data.InspectionLogBook[0].Answer === 'Yes' &&
                        item.Option === 'Yes'
                        ? true
                        : datasource[rowIndex].Answer === 'Yes' && item.Option === 'Yes'
                          ? true
                          : datasource[rowIndex].Answer === 'No' && item.Option === 'No'
                            ? true
                            : data.InspectionLogBook &&
                              data.InspectionLogBook[0] &&
                              data.InspectionLogBook[0].Answer === 'No' &&
                              item.Option === 'No'
                              ? true
                              : false
                    }
                    onChange={(e) => onCheckboxChange(e, rowIndex, item.Option, item)}
                    style={{ color: 'rgb(217,142,4)' }}
                  >
                    {translation(item.Option)}
                  </Checkbox>
                  <br />
                </>
              );
            })}
        </Space>
      )
    },
    {
      title: translation('Attachment'),
      dataIndex: 'Attachment',
      key: 'Attachment',
      render: (_, record, rowIndex) => {
        const { InspectionLogBook } = record;
        return (
          <FileBase64
            style={{ width: '100%' }}
            Attachments={
              record.InspectionLogBook && record.InspectionLogBook.length !== 0
                ? InspectionLogBook &&
                  Array.isArray(InspectionLogBook) &&
                  InspectionLogBook[0] &&
                  InspectionLogBook[0].Attachments
                  ? InspectionLogBook[0].Attachments
                  : []
                : datasource[rowIndex].Attachments
            }
            disableAdd={
              record.InspectionLogBook && record.InspectionLogBook.length !== 0 ? true : false
            }
            fileUpload={(values, key, fileDataObject) =>
              fileupload(values, key, fileDataObject, rowIndex)
            }
          ></FileBase64>
        );
      }
    },
    {
      title: translation('Remarks'),
      dataIndex: 'Remarks',
      key: 'Remarks',
      render: (_, record, rowIndex) => {
        const { InspectionLogBook } = record;
        if (
          record &&
          record.Answers &&
          datasource &&
          datasource[rowIndex] &&
          datasource[rowIndex].Answer
        ) {
          const list = record.Answers.map((param, index) => {
            if (
              param.Option === datasource[rowIndex].Answer &&
              param.Actions &&
              Array.isArray(param.Actions) &&
              param.Actions.length > 0
            ) {
              return (
                <TextAreaComponent
                  key={index}
                  rows={3}
                  disabled={
                    record.InspectionLogBook && record.InspectionLogBook.length !== 0
                      ? true
                      : false
                  }
                  defaultValue={
                    record.InspectionLogBook &&
                      record.InspectionLogBook[0] &&
                      record.InspectionLogBook.length !== 0
                      ? record.InspectionLogBook &&
                      record.InspectionLogBook[0] &&
                      record.InspectionLogBook[0].Remarks
                      : ''
                  }
                  style={{ width: '100%' }}
                  placeholder={translation('Please input Remarks')}
                  onChange={(e) => setRemarks(e.target.value, rowIndex)}
                />
              );
            } else {
              return InspectionLogBook &&
                Array.isArray(InspectionLogBook) &&
                InspectionLogBook[0] &&
                InspectionLogBook[0].Remarks
                ? InspectionLogBook[0].Remarks
                : '';
            }
          });
          return list;
        } else {
          return InspectionLogBook &&
            Array.isArray(InspectionLogBook) &&
            InspectionLogBook[0] &&
            InspectionLogBook[0].Remarks
            ? InspectionLogBook[0].Remarks
            : '';
        }
      }
    },
    {
      title: translation('Action'),
      key: 'action',
      render: (_, data, rowIndex) => (
        <Space>
          <Button
            onClick={() => {
              onFormsubmit(rowIndex);
            }}
            disabled={
              data.InspectionLogBook &&
                data.InspectionLogBook[0] &&
                data.InspectionLogBook.length !== 0
                ? true
                : false
            }
          >
            {translation(constant.submit)}
          </Button>
        </Space>
      )
    }
  ];
  const leftPaneStyle = {
    borderRight: windowWidth >= 768 ? '1px dashed #ccc' : 'none',
    // borderBottom: windowWidth < 768 ? '1px dashed #ccc' : 'none',
    width: windowWidth >= 768 ? '30%' : '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 100px)', // Use vh units for better height management
    boxSizing: 'border-box',
    padding: '10px',
    height: windowHeight - 350 > 300 ? windowHeight - 350 : 300, // minimum height for usability
  };

  const rightPaneStyle = {
    width: windowWidth >= 768 ? '70%' : '100%',
    padding: '20px 15px',
    borderLeft: windowWidth >= 768 ? '3px dashed' : 'none',
    borderTop: windowWidth < 768 ? '3px dashed' : 'none',
    // opacity: formObjectId && formObjectId !== '' ? 1 : 0.6,
    // pointerEvents: formObjectId && formObjectId !== '' ? 'auto' : 'none',
    boxSizing: 'border-box',
    maxHeight: 'calc(100vh - 100px)',
    overflowY: 'auto',
    // filter: formObjectId && formObjectId !== '' ? 'none' : 'grayscale(0.5)',
    transition: 'opacity 0.3s ease, filter 0.3s ease',
  };

  return (
    <StyledHomepageSides>
      <Form
        name="SR"
        ref={formHeader}
        onFinish={(data) => onFormsubmit1(data)}
        initialValues={formObject}
        layout="vertical"
      >
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button type="primary" htmlType="submit">
            {translation(constant.submit)}
          </Button>
        </div>
        <StyledBoxHeader>
          <StyledBox>
            <Form.Item
              label={translation(constant.InspectionId)}
              name="InspectionId"
              rules={[{ required: true, message: 'Input InspectionId!' }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation('InspectionId')}
                value={formObject && formObject.InspectionId}
                disabled
                onChange={(e) => handleChange(e.target.value, 'InspectionId')}
              />
            </Form.Item>
            <Form.Item
              label={translation(constant.Description)}
              name="Description"
              rules={[{ required: true, message: 'Input Description!' }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation('Description')}
                value={formObject && formObject.Description}
                disabled
                onChange={(e) => handleChange(e.target.value, 'Description')}
              />
            </Form.Item>
            <Form.Item
              label={translation(constant.createdBy)}
              name="CreatedBy"
              rules={[{ required: false, message: 'Select Created By' }]}
            >
              <Select
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation('Created By')}
                onChange={(value) => handleChange(value, 'CreatedBy')}
              >
                {usersList &&
                  Array.isArray(usersList) &&
                  usersList.map((users, index) => {
                    return (
                      <Option key={index} value={users.Id}>
                        {' '}
                        {users.FirstName}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>

            <Form.Item
              label={translation(constant.CreatedDate)}
              name="InspectionCreationTime"
              rules={[{ required: false, message: 'Created Date' }]}
            >
              <DatePicker
                format={'YYYY-MM-DD HH:mm:ss'}
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation('Created Date')}
              />
            </Form.Item>
            <Form.Item
              label={translation(constant.actualFinish)}
              name="ActualEndDate"
              rules={[{ required: false, message: 'Actual Finish' }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                placeholder={translation('ActualFinish')}
              />
            </Form.Item>
            <Form.Item
              label={translation(constant.status)}
              name="StatusId"
              rules={[{ required: true, message: 'Please Select Status' }]}
            >
              <Select
                placeholder={translation('Select Status')}
                onChange={(value) => handleChange(value, 'StatusId')}
                style={{ width: '100%' }}
              >
                {statusList &&
                  Array.isArray(statusList) &&
                  statusList.map((status, index) => {
                    return (
                      <Option key={index} value={status.Value}>
                        {status.Key}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>

          </StyledBox>
        </StyledBoxHeader>
      </Form>
      <div style={containerStyle}>
        <div style={leftPaneStyle}>
          <Tree
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            style={{ width: '100%', flex: '50%', padding: '20px' }}
            onSelect={onSelect}
            showLine
            defaultExpandAll={true}
            switcherIcon={<DownOutlined />}
          >
            {renderTreeNodes(treeData)}
          </Tree>
        </div>

        <div style={rightPaneStyle}>
          <StyledTable size="small" columns={columns} dataSource={datasource} />
        </div>
      </div>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(InspectionForm);